module.exports = __webpack_public_path__ + "img/app-hls.115587a4.webp";